import axios from "../../axios";

export const getEmipayments = async ( 
  accountId,
  aggregated = false,
  type= "emi"
) => {
  try {
    const url = aggregated ? `/api/v3/aggregate/analysis/patterns?reportReferenceId=${accountId}&type=${type}` : `/api/v3/analysis/patterns?accountId=${accountId}&type=${type}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
}; 

export const getLoans = async ( 
    accountId,
    aggregated = false,
    type= "loans"
  ) => { 
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/patterns?reportReferenceId=${accountId}&type=${type}` : `/api/v3/analysis/patterns?accountId=${accountId}&type=${type}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  }

  export const getSalary = async (
    accountId,
    aggregated = false,
    type= "salary"
  ) => {
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/patterns?reportReferenceId=${accountId}&type=${type}` : `/api/v3/analysis/patterns?accountId=${accountId}&type=${type}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  };

  
  export const getRecurringPayments = async (
    accountId,
    aggregated = false,
    type= "recurringPayments"
  ) => {
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/patterns?reportReferenceId=${accountId}&type=${type}` : `/api/v3/analysis/patterns?accountId=${accountId}&type=${type}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  };
 

export const getLoanAnalysis = async (   
    accountId,
    aggregated = false
  ) => {
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/loanAnalysis?reportReferenceId=${accountId}` : `/api/v3/analysis/loanAnalysis?accountId=${accountId}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  };

  export const getDailyBalance = async (accountId, aggregated = false) => {
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/dailyBalance?reportReferenceId=${accountId}` : `/api/v3/analysis/dailyBalance?accountId=${accountId}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  };

  export const getCashflow = async (
    accountId,
    aggregated = false
  ) => {
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/cashflow?reportReferenceId=${accountId}` : `/api/v3/analysis/cashflow?accountId=${accountId}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  };

  export const getMonthlyCounterparty = async (
    accountId,
    aggregated = false
  ) => {
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/monthlyCounterparty?reportReferenceId=${accountId}` : `/api/v3/analysis/monthlyCounterparty?accountId=${accountId}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  };

  export const getBizCashflow = async (
    accountId,
    aggregated = false
  ) => {
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/businessCashFlow?reportReferenceId=${accountId}` : `/api/v3/analysis/businessCashFlow?accountId=${accountId}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  };